<template>
    <div class="login-box" style="min-width: 1200px;">
        <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
        <div style="width: 100%;">
            <img src="../../static/img/rm_brand_img/top_back_img.png" style="width: 100%;" alt="">
        </div>
        <div style="width: 70%;margin-left: 13%;margin-bottom: 50px;">
            <div class="div_button" v-for="(item, index) in array_back" :key="index">
                <div style="padding: 18px;" @click="button_click(item)">
                    <img :src="item.img" alt="" style="width: 100%;">
                    <div style="color: #7A7A7A;font-size: 14px;margin-top: 14px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.name}}</div>
                </div>
            </div>
        </div>
        <!-- 尾部 -->
        <RMBottomDiv></RMBottomDiv>
    </div>
</template>
<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue';
    export default {
        data() {
            return {
                scroll: '',
                scroll100: true,
                scroll700: false,
                array_back:[
                    {//御玫瑰
                        "img":require("../../static/img/rm_brand_img/rm_brand_img_yumeigui_top.png"),
                        "name":"御玫瑰健康美肤：解决会员预约问题，提升到店率",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/rm_brand_img_yumeigui_details.png"),
                            "content_one":"很多美容院因为缺少管理，很难招聘到好的美容师、很难留住优秀的员工、就连客户档案都很乱、甚至根本没有客户档案。找美网店务经营管理软件中的预约功能方便快捷，可以有效缩短服务时间。用户不需要主动联系商家，只需要在手机上动动手指即可快速，轻松地完成整个预约过程，并且所有这些操作都在微信环境中完成，而无需安装其他应用程序，可以大大提升用户体验。",
                            "content_two":[
                                "顾客随时与商家沟通，深度咨询连锁店产品或服务，提升转化率。美容师也可以通过找美网店务经营管理系统随时按项目查看预约情况、按天今日预约、时段今日预约情况等，将预约情况摸清，提供会员满足的服务和商品。如果会员临时取消预约，也不需要跑到店里，只需要进行简单操作即可。",
                                "御玫瑰健康美肤：通过找美网SaaS系统实现线上预约，不仅是与传统零售无缝连接，线上预约线下消费，实现全渠道融合。"
                            ],
                            "title":"解决会员预约问题，提升到店率",
                            "address":"广东·广州",
                            "title_up":"无",
                            "title_down":"解决充值卡项问题，让消费简单高效"
                        }
                    },
                    {//欧赛媤
                        "img":require("../../static/img/rm_brand_img/rm_brand_img_ousaisi_top.png"),
                        "name":"山东·欧赛媤美容连锁：解决充值卡项问题，让消费简单高效",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/rm_brand_img_ousaisi_details.png"),
                            "content_one":"美容院会员充值消费场景怎么样？美容院会员卡一站式的在线充值活动如何开展才能吸引客户的注意力？如何让门店快速引流裂变会员客户，让门店客源不断，回笼资金简单高效？丰富储值营销玩法，加速资金回笼提业绩;储值返赠金额、积分、商品、项目等，充得越多返赠越多，吸引客户办卡充值;可设定会员生日、每周/月哪几天、特定时间段等节点自动开展储值赠送促销，营销自动化，彻底释放运营潜力;活动提醒信息支持批量发送，精准触达，快速曝光，活动效果更有保障。",
                            "content_two":[
                                "找美网店务经营管理系统实现会员卡跨店储值、消费收银的结算、会员卡跨店积分和积分活动的管理实施。而且连锁店会员充值系统能记录会员消费信息，可以跨店进行消费使会员更加大胆储值消费。",
                                "欧赛媤美容连锁，通过会员卡储值管理，让客户更放心，让商家更快收回现金流，让连锁店管理更方便快捷、省时省力、高效。"
                            ],
                            "title":"解决充值卡项问题，让消费简单高效",
                            "address":"山东·淄博",
                            "title_up":"解决会员预约问题，提升到店率",
                            "title_down":"解决会员收银划卡，提升会员运营效率。"
                        }
                    },
                    {//爱美空间
                        "img":require("../../static/img/rm_brand_img/rm_brand_back_aimei_top.png"),
                        "name":"东莞·爱美空间美容连锁：解决会员收银划卡，提升会员运营效率。",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/rm_brand_back_aimeikongjian_details.png"),
                            "content_one":"找美网店务经营管理系统“收银划卡”对比传统的收银方式，首先所支持的消费支付方式更加多样化，可以支持支付宝、微信、电子券、储值卡、银联、现金、转账等支付方式，更好的提升了会员的消费体验，能够满足会员的不同需求，让收银管理也更加的方便。",
                            "content_two":[
                                "会员消费数据等系统后台可直接进行统计，方便进行核算和查看，系统还有员工提成功能，可提前设置好不同等级的员工提成，当员工产生销售或者医疗美容师登记后，系统可自动增加员工结算，到核算工资时系统可以自动调取出提成额，非常的方便快捷。",
                                "爱美空间美容连锁，通过找美网会员收银划卡及电子档案功能，实现全面无纸化经营，建立会员电子档案本、记录会员资产信息、解决库存累计消耗、方便挖掘消费潜力，真正做到智能一体化经营管理。"
                            ],
                            "title":"解决会员收银划卡，提升会员运营效率。",
                            "address":"广东·东莞",
                            "title_up":"解决充值卡项问题，让消费简单高效",
                            "title_down":"解决库存管理烦恼，杜绝资源浪费"
                        }
                    },
                    {//路伊威莎
                        "img":require("../../static/img/rm_brand_img/rm_brand_img_luyiweisha_top.png"),
                        "name":"四川·路伊威莎美容连锁：解决库存管理烦恼，杜绝资源浪费",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/rm_brand_img_luyiweisha_details.png"),
                            "content_one":"美容院如何更好地解决库存烦恼？找美网经营管理系统，对店铺的进销存实现轻松实现商品入库、销售出库操作，科学盘点库存。提供库存预警功能，实现美容连锁店铺的资源的合理调拨。",
                            "content_two":[
                                "实时掌握商品库存，降低美容院的库存：在商品销售过程中，根据每日销售报表，定期盘点。分析销售趋势，快速反应，第一时间发现畅销品，及时追单。加快补货频率，保证货品充足，最大程度满足销售;商品调拨遵循就近原则、横向调拨，哪个店卖得好卖的快就往哪个店集中，同时尽量保证进出货总量平衡，以确保各店的安全库存量。",
                                "路伊威莎美容连锁，通过找美网实现销售、采购、库存记录详情轻松查询，当库存不足时有预警提示，减少积压、控制成本，确保企业资金流动，智能化库存管理，一键盘点、跨店调拨、精准统计、科学管理门店物资，实现资源合理配置的同时，杜绝资源浪费，提高经营效益。"
                            ],
                            "title":"解决库存管理烦恼，杜绝资源浪费",
                            "address":"四川·眉山",
                            "title_up":"解决会员收银划卡，提升会员运营效率。",
                            "title_down":"解决引流拓客难题，彻底引爆线上流量。"
                        }
                    },
                    {//燕子尊享
                        "img":require("../../static/img/rm_brand_img/brand_back_spa.png"),
                        "name":"福建·燕子尊享SPA美容：解决引流拓客难题，彻底引爆线上流量。",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/brand_back_spa_details.png"),
                            "content_one":"美容院如何做好线上引流拓客？线下消费也需要开拓线上渠道，随着第三方平台的流量越来越贵，微信商城就成为了主流的营销渠道。找美网微信分销商城成为美业线上线下融合驱动力，可以覆盖预约、营销、管理、财务、员工、顾客等方面，进行店铺全渠道经营管理。",
                            "content_two":[
                                "微信商城在面向顾客方面，具备着很大的优势，不需要安装更新，不会给顾客造成什么负担，顾客在微信上就可以进行预约及评价等一系列的操作，顾客可以在线选择心仪美容师进行预约服务，实现专属个人服务，这样增加顾客对品牌的认同感。",
                                "燕子尊享，通过找美网微信分销商城设置限时秒杀、积分兑换等促销活动，短短一个线上商城业绩收入增加76.28万，彻底引爆线上流量。"
                            ],
                            "title":"解决引流拓客难题，彻底引爆线上流量。",
                            "address":"福建·福州",
                            "title_up":"解决库存管理烦恼，杜绝资源浪费",
                            "title_down":"壹号医美医疗机构：解决统计报表难题"
                        }
                    },
                    {//圳·壹号
                        "img":require("../../static/img/rm_brand_img/brand_back_yihao.png"),
                        "name":"深圳·壹号医美医疗机构：解决统计报表难题",
                        "content":{
                            "img":require("../../static/img/rm_brand_img/brand_back_yihao_details.png"),
                            "content_one":"医疗美容店业绩报表针对不同的客户提供相应服务？找美网经营管理系统对门店的会员，非会员，散客进行分析，判断他们的活跃度，对他们进行分类，比如说活跃客户，还有沉睡客户，另外医疗美容店业绩报表还可以根据会员常点的项目，和会员等级进行分类，针对不同的客户，推出相应的服务，增加会员黏度。",
                            "content_two":[
                                "自动统计生成“员工业绩表、会员资产表、会员排行表、营业统计表、消耗明细表、财务分析表、门店负债表、品项分析表、品项占比表、门店出库表”等以上所有报表数据，让管理层随时掌控各个门店的消费与增长情况。",
                                "找美网各项报表自动统计功能，帮助壹号医美解决门店管理和会员分析等经营问题，大大节省了人力物力。"
                            ],
                            "title":"解决统计报表难题",
                            "address":"广东·深圳",
                            "title_up":"解决引流拓客难题，彻底引爆线上流量。",
                            "title_down":"无"
                        }
                    }
                ],
            }
        },
        mounted() {
            //获取高度
            window.addEventListener("scroll", this.dataScroll, true);
          
        },
        methods: {
            button_click(item){
                this.$router.push({path:"./RMBrand_Details",query:{model:JSON.stringify(item)}});

            },
            dataScroll(event) {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
            },
            loadSroll: function () {
                if (this.scroll <= 100) {
                    this.scroll100 = true
                } else {
                    this.scroll100 = false
                }
                if (this.scroll > 100) {
                    this.scroll700 = true
                } else {
                    this.scroll700 = false
                }
            },
        },
        components:{
            RMBottomDiv,
            RMTopDiv

        },
        watch: {
            scroll: function () {
                this.loadSroll();
            }
        },
    }
</script>
<style scoped>
    .login-box {
        width: 100%;
        height: 100%;
        position: fixed;
        background: #fff;
        overflow-y: auto;
    }
    .div_button{
        width: 30%;
        display: inline-block;
         border: 1px solid #F0F0F0;
         margin-left: 3%;
         margin-top: 3%;
         cursor: pointer;
    }
    .div_button:hover{
        transition: box-shadow 0.5s;
        -webkit-transition: 0.5s;
        box-shadow: 0px 0px 24px 10px rgba(219, 219, 219, 0.5);
    }
    
</style>


// WEBPACK FOOTER //
// src/page/RMBrand.vue